import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Modal, Alert, Button, Form, Col, Row } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const EditarMonedaMontoModal = ({ handleClose, show, idEdicion, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const [buscando, setBuscando] = React.useState(true)

  const infoDetalleAsientoRef = React.useRef(null)

  React.useEffect(() => {
    AsientoContableService.obtenerDetallexIdAsInfoMonedaMonto(idEdicion)
      .then(({ data }) => {
        if (data) {
          infoDetalleAsientoRef.current = {
            moneda: data.moneda,
            montoNacional: data.montoNacional,
            montoExtranjero: data.montoExtranjero,
            tipo: data.tipo,
            tipoCambio: data.tipoCambio
          }
        }
      })
      .catch(() => {
        infoDetalleAsientoRef.current = null
      })
      .finally(() => {
        setBuscando(false)
      })
  }, [idEdicion])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      AsientoContableService.actualizarDetallexIdAsMonedaMonto(idEdicion, data)
        .then(() => {
          __zariContext.snack('success', 'Se ha actualizado los datos.')
          reloadTable()
          handleClose()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, idEdicion, reloadTable, handleClose]
  )

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Editar moneda y monto</Modal.Title>
      </Modal.Header>
      {buscando ? (
        <>
          <Modal.Body>
            <Alert color='info'>Obteniendo información.</Alert>
          </Modal.Body>
          <Modal.Footer>
            <Button color='secondary' outline onClick={handleClose}>
              Cancelar
            </Button>
          </Modal.Footer>
        </>
      ) : (
        <>
          {infoDetalleAsientoRef.current ? (
            <Formik initialValues={infoDetalleAsientoRef.current} onSubmit={onSubmit}>
              {({ handleSubmit, isSubmitting, errors, touched }) => (
                <>
                  <Modal.Body>
                    <Form>
                      <FormGroups.TipoFromGroup fIsSubmitting={isSubmitting} iError={errors.tipo} iTouched={touched.tipo} />
                      <Row>
                        <Col md={6}>
                          <FormGroups.MonedaFromGroup fIsSubmitting={isSubmitting} iError={errors.moneda} iTouched={touched.moneda} />
                        </Col>
                        <Col md={6}>
                          <FormGroups.TipoCambioFromGroup fIsSubmitting={isSubmitting} iError={errors.tipoCambio} iTouched={touched.tipoCambio} />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroups.MontoNacionalFromGroup
                            fIsSubmitting={isSubmitting}
                            iError={errors.montoNacional}
                            iTouched={touched.montoNacional}
                          />
                        </Col>
                        <Col md={6}>
                          <FormGroups.MontoExtranjeroFromGroup
                            fIsSubmitting={isSubmitting}
                            iError={errors.montoExtranjero}
                            iTouched={touched.montoExtranjero}
                          />
                        </Col>
                      </Row>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button color='secondary' outline onClick={handleClose}>
                      Cancelar
                    </Button>
                    <Button onClick={handleSubmit}>Guardar</Button>
                  </Modal.Footer>
                </>
              )}
            </Formik>
          ) : (
            <>
              <Modal.Body>
                <Alert color='danger'>No se pudo obtener información del detalle.</Alert>
              </Modal.Body>
              <Modal.Footer>
                <Button color='secondary' outline onClick={handleClose}>
                  Cancelar
                </Button>
              </Modal.Footer>
            </>
          )}
        </>
      )}
    </Modal>
  )
}

export default React.memo(EditarMonedaMontoModal)
